<template>
  <div>
    <FormulateForm name="documentos" v-model="values">
      <div class="clube-vantagens-upload row">
        <div class="col-md-3">
          <FormulateInput
            type="file"
            name="planilha"
            label="Planilha de Usuários"
            validation="mime:application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        </div>
        <div class="col-md-6">
          <div class="alert alert-warning w-100 mt-3 text-justify">
            Atenção! Para o envio de usuários em massa, você precisa seguir o
            padrão de arquivo disponível
            <a href="javascript:void(0)" @click="download">aqui para download</a
            >. Insira os dados no arquivo abaixo das colunas informadas e envie
            no campo ao lado.
          </div>
        </div>
      </div>
      <div class="mt-3 alert alert-danger w-100" v-if="cpfInvalidos">
        Segue a lista de CPFs Inválidos encontrados no arquivo, verifique e
        tente novamente.
        <ul class="mt-2">
          <li v-for="(value, k) in cpfInvalidos" :key="k">- {{ value }}</li>
        </ul>
      </div>
      <div class="row mt-3">
        <div class="form-check col-md-6 d-flex pl-2 pb-2 align-items-center">
          <input
            type="checkbox"
            id="ciente"
            v-model="aceite"
            name="ciente"
          /><label for="ciente" class="small ml-1"
            >Declaro estar ciente e de acordo com as condições previstas no
            Termo de Uso do Clube de Vantagens, me responsabilizando pelas
            informações fornecidas
          </label>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            @click="cancelar"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Enviar"
            :class="{ disabled: loading || !aceite }"
            @click="!loading && aceite ? enviar() : ''"
            nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">ENVIANDO...</span>
            <span v-else>ENVIAR</span>
          </Botao>
        </div>
      </div>
    </FormulateForm>
  </div>
</template>
<script>
import Botao from "@/components/botoes/Botao";
export default {
  name: "FormEndereco",
  components: { Botao },
  props: {
    tipoProduto: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      values: {},
      loading: false,
      usuarios: [],
      solicitarProdutos: null,
      nUsuario: 1,
      produto: this.tipoProduto,
      envioArquivos: false,
      cpfInvalidos: null,
      aceite: false,
    };
  },
  methods: {
    cancelar() {
      this.values = {};
      this.$emit("click", {
        props: {
          uploadArquivo: false,
        },
      });
    },
    validar() {
      this.solicitarProdutos = false;
      this.$formulate.submit("Cadastro");
    },
    maisprodutos(type) {
      this.solicitarProdutos = type;
      this.$formulate.submit("Cadastro");
    },
    enviar() {
      this.loading = true;
      const form = new FormData();

      form.append("file", this.values.planilha.fileList[0]);

      this.$http
        .post(`/api/Clube/EnviarPlanilhaFuncionariosClubeVantagens`, form)
        .then((response) => {
          console.log(response);
          this.loading = false;
          if (response.status === 200) {
            if (response.data.cpfsInvalidos) {
              this.$toast.open({
                message: response.data.mensagem,
                type: "error",
                duration: 6000,
              });
              this.cpfInvalidos = response.data.cpfsInvalidos;
            } else {
              this.$toast.open({
                message: response.data.mensagem,
                type: "success",
                duration: 6000,
              });
              this.$router.push({ name: "clube-painel" });
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toast.open({
            message: "Erro no envio dos seus arquivos, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
    addUsuario() {
      var usuario = {
        name: "Usuário",
      };
      this.nUsuario++;
      this.usuarios.push(usuario);
    },
    remover(k) {
      this.usuarios.splice(k, 1);
      if (!this.usuarios.length) {
        this.nUsuario = 1;
      }
    },
    download() {
      this.$http
        .get("/api/Clube/BuscarPlanilhaFuncionariosClubeVantagens")
        .then((response) => {
          var bin = atob(response.data.file.fileContents);
          var ab = this.s2ab(bin);
          let blob = new Blob([ab]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = response.data.file.fileDownloadName;
          link.click();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          if (error.response.status === 400) {
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
            this.$router.push({ name: "agenda" });
          }
          this.loading = false;
        });
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.clube-vantagens-upload /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  @import "../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
  input {
    padding: 5px 7px;
  }
  .formulate-input[data-type="radio"] {
    .formulate-input-element {
      display: flex;
      .formulate-input {
        margin-right: 7px;
        label {
          margin-left: 2px;
        }
      }
    }
  }
  .formulate-input[data-classification="textarea"] {
    textarea {
      background: white;
    }
  }
  .form-wrap {
    background: $dark-100;
    border-radius: 6px;
  }
}
.label {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
